














































import Vue, { PropType } from 'vue'
import XButton from '@/components/atoms/Button/XButton.vue'

export interface CreditCard {
  cardId: string
  expYear: string
  expMonth: string
  name: string
  type: string
  isMain: boolean
}

export default Vue.extend({
  name: 'CreditCardInfo',
  components: { XButton },
  props: {
    creditCard: {
      type: Object as PropType<CreditCard>,
      required: true,
    },
  },
  methods: {
    onClickDelete() {
      this.$emit('click:delete', this.creditCard)
    },
  },
})
